module.exports = __webpack_public_path__ + "static/media/loyality.6787cf03.svg";